"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineQueryOperators = void 0;
const azure_query_js_1 = require("azure-query-js");
var queryOperators = [
    "where",
    "select",
    "orderBy",
    "orderByDescending",
    "skip",
    "take",
    "includeTotalCount",
];
var copyOperator = function (table, operator) {
    table.prototype[operator] = function () {
        var table = this;
        console.log("table", table);
        var query = new azure_query_js_1.Query(table.getTableName());
        query.read = function (parameters) {
            return table.read(query, parameters);
        };
        console.log("query", query);
        return query[operator].apply(query, arguments);
    };
};
function defineQueryOperators(table) {
    var i = 0;
    for (; i < queryOperators.length; i++) {
        copyOperator(table, queryOperators[i]);
    }
}
const _defineQueryOperators = defineQueryOperators;
exports.defineQueryOperators = _defineQueryOperators;
